var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1879",
    "data-name": "Groupe 1879",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    "data-name": "Rectangle 1764",
    width: 48,
    height: 48,
    fill: "none",
    opacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search_FILL1_wght400_GRAD0_opsz48",
    d: "M31.6,34.065,26.65,28.8a11.018,11.018,0,0,1-3.5,2.025,12.374,12.374,0,0,1-4.25.725A12.449,12.449,0,0,1,9.75,27.8,12.332,12.332,0,0,1,6,18.75,12.332,12.332,0,0,1,9.75,9.7a12.391,12.391,0,0,1,9.1-3.75A12.25,12.25,0,0,1,27.875,9.7,12.374,12.374,0,0,1,31.6,18.75a12.472,12.472,0,0,1-.7,4.15,12.691,12.691,0,0,1-2.1,3.75l5,5.215ZM18.85,28.55a9.357,9.357,0,0,0,6.9-2.875A9.481,9.481,0,0,0,28.6,18.75a9.481,9.481,0,0,0-2.85-6.925,9.357,9.357,0,0,0-6.9-2.875,9.5,9.5,0,0,0-6.975,2.875A9.439,9.439,0,0,0,9,18.75a9.439,9.439,0,0,0,2.875,6.925A9.5,9.5,0,0,0,18.85,28.55Z",
    transform: "translate(4 4.05)",
    fill: "#7d7d7d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bfa06e99596f80b1eaf046a8d01ef6b9.svg";
export { ForwardRef as ReactComponent };